import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import "./billingData.css";
import Swal from "sweetalert2";
import CustomSelect from "../capture/custom-select";
import axios from "axios";

function BillingData({ masterNumber, initialData, onInvoiceCreated }) {
  const {
    resp,
    amount_handling,
    amount_refri,
    amount_conge,
    amount_screening,
    amount_dg_fee,
    amount_custom_value,
    amount_dg_exmept,
    amount_ice,
    amount_c_rkn,
    amount_c_rap,
    amount_p_rkn,
    amount_p_rap,
    subtotal,
    iva,
    total,
  } = initialData;

  const [agents, setAgents] = useState([]);
  const [clients, setClients] = useState([]);
  const [paymentConditions, setPaymentConditions] = useState([]);
  const [conceptosDinamicos, setConceptosDinamicos] = useState([]);

  const [formData, setFormData] = useState({
    agencia: "",
    cliente: "",
    clientId: "",
    usoCfdi: "",
    condicionesPago: "",
    metodoPago: "",
    cuentaPago: "",
    valorAduana: "0",
    observaciones: "",
  });

  const [customValueCalculado, setCustomValueCalculado] = useState(amount_custom_value);
  const [cantidades, setCantidades] = useState(Array(8).fill(0));
  const [flejeEmpaqueMonto, setFlejeEmpaqueMonto] = useState(0);
  const [subtotalView, setSubtotal] = useState(subtotal);
  const [ivaView, setIva] = useState(iva);
  const [totalView, setTotal] = useState(total);

  //Obtener reglas comerciales (Actualiza TODA la tabla)
  const getExpRules = async (clientId, actualesCantidades = cantidades, aduanaValue = formData.valorAduana) => {
    try {
      const params = new URLSearchParams({
        strip_skid_160: actualesCantidades[0],
        strip_skid_medium: actualesCantidades[1],
        strip_loose: actualesCantidades[2],
        vitafilm_skid_160: actualesCantidades[3],
        vitafilm_skid_medium: actualesCantidades[4],
        vitafilm_loose: actualesCantidades[5],
        pallet_supply_std: actualesCantidades[6],
        pallet_supply_eur: actualesCantidades[7],
      }).toString();

      const body = {
        client_id: clientId || null,
        master_id: resp?.master_id,
        house_id: initialData?.house_id || -1,
        custom_value: aduanaValue || 0,
        admin_invoice: initialData?.admin_invoice ? 1 : 0,
        weight: resp?.master_chargeable_weight || 0,

        strip_skid_160: actualesCantidades[0],
        strip_skid_medium: actualesCantidades[1],
        strip_loose: actualesCantidades[2],
        vitafilm_skid_160: actualesCantidades[3],
        vitafilm_skid_medium: actualesCantidades[4],
        vitafilm_loose: actualesCantidades[5],
        pallet_supply_std: actualesCantidades[6],
        pallet_supply_eur: actualesCantidades[7],
      };

      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/expo_invoices/get_exp_rules?${params}`,
        body,
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } }
      );
      setConceptosDinamicos(res.data);
    } catch (e) {
      console.error("Error en reglas comerciales", e);
    }
  };

  // Condiciones de pago por cliente
  const getPaymentConditionsClient = async (clientId) => {
    if (!clientId) return;
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/expo_invoices/get_payment_conditions_client?client_id=${clientId}`,
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } }
      );
      if (res.data) {
        setPaymentConditions(Object.entries(res.data[1]).map(([id, name]) => ({ id, name })));
        handleFormChange("condicionesPago", res.data[0]);
      }
    } catch (e) {
      console.error("Error en condiciones de pago", e);
    }
  };

  // Embalaje (Ya lo tenías, se mantiene)
  const getPackagingAmount = async (nuevasCantidades) => {
    try {
      const body = {
        strip_skid_160: nuevasCantidades[0],
        strip_skid_medium: nuevasCantidades[1],
        strip_loose: nuevasCantidades[2],
        vitafilm_skid_160: nuevasCantidades[3],
        vitafilm_skid_medium: nuevasCantidades[4],
        vitafilm_loose: nuevasCantidades[5],
        pallet_supply_std: nuevasCantidades[6],
        pallet_supply_eur: nuevasCantidades[7],
        master_id: resp?.master_id,
        house_id: initialData?.house_id || 0
      };

      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/expo_invoices/get_packaging_amount`,
        body,
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } }
      );

      const montoCalculado = response.data[0] || 0;
      setFlejeEmpaqueMonto(montoCalculado);

      // Si hay un cliente seleccionado, refrescar reglas comerciales también
      if (formData.clientId) getExpRules(formData.clientId, nuevasCantidades);

    } catch (error) {
      console.error("Error al obtener monto de empaque:", error);
    }
  };

  const getCustomValue = async (aduanaValue) => {
    try {
      const body = {
        custom_value: aduanaValue,
        master_id: resp?.master_id,
        house_id: initialData?.house_id || -1,
        client_id: formData.clientId
      };

      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/expo_invoices/get_custom_value`,
        body,
        { headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` } }
      );

      const monto = response.data[0] || 0;
      setCustomValueCalculado(monto);
      return monto;
    } catch (error) {
      console.error("Error al obtener monto de valor aduana:", error);
      return 0;
    }
  };

  const handleFormChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleCantidadInputChange = (index, value) => {
    const numValue = Math.max(0, parseInt(value) || 0);
    const updatedCantidades = [...cantidades];
    updatedCantidades[index] = numValue;
    setCantidades(updatedCantidades);
  };

  const handleInputFocus = (index, isAduana = false) => {
    if (isAduana) {
      if (formData.valorAduana === "0" || formData.valorAduana === 0) {
        handleFormChange("valorAduana", "");
      }
    } else {
      if (cantidades[index] === 0 || cantidades[index] === "0") {
        const updatedCantidades = [...cantidades];
        updatedCantidades[index] = "";
        setCantidades(updatedCantidades);
      }
    }
  };

  const handleCantidadBlur = (index) => {
    let currentVal = cantidades[index];
    if (currentVal === "" || currentVal === null) {
      const updatedCantidades = [...cantidades];
      updatedCantidades[index] = 0;
      setCantidades(updatedCantidades);
      currentVal = 0;
    }
    getPackagingAmount(cantidades);
    getExpRules(formData.clientId || null, cantidades, formData.valorAduana);
  };

  const onSelectCliente = (selected) => {
    const cid = selected ? selected.id : "";
    handleFormChange("cliente", selected ? selected.name : "");
    handleFormChange("clientId", cid);
    if (cid) {
      getExpRules(cid);
      getPaymentConditionsClient(cid);
    }
  };

  // Función para obtener el monto dinámico (Prioriza WS sobre initialData)
  const getMontoFinal = (chargeId, initialVal) => {
    const regla = conceptosDinamicos.find((c) => c.exp_charge_id === chargeId);
    if (regla) return regla.amount.toString().replace(/,/g, "");

    // Manejo especial para el ID 18 si ya fue recalculado manualmente
    if (chargeId === 18) return String(customValueCalculado).replace(/,/g, "");
    // Manejo para ID 19
    if (chargeId === 19) return String(flejeEmpaqueMonto).replace(/,/g, "");

    return Array.isArray(initialVal) ? initialVal[0] : initialVal || "0.00";
  };


  useEffect(() => {
    const getInitialData = async () => {
      try {
        const resAgents = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/agents`, {
          headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` }
        });
        if (resAgents.data.code === 1) setAgents(resAgents.data.data);

        const resClients = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/v1/exp_clients`, {
          headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` }
        });
        if (resClients.data.code === 1) setClients(resClients.data.data);
      } catch (e) { console.error(e); }
    };
    getInitialData();
  }, []);

  // Carga inicial automática de montos base
  useEffect(() => {
    if (resp?.master_id) {
      getPackagingAmount(cantidades);
      getExpRules(null, cantidades, formData.valorAduana);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resp?.master_id]);

  // Recalcular Totales
  useEffect(() => {

    // 1. Definimos los montos fijos iniciales (los que no vienen del back)
    // Limpiamos comas de los valores que vienen en initialData
    const fijos = [
      { id: 22, val: amount_dg_exmept },
      { id: 23, val: amount_ice },
      { id: 30, val: amount_c_rkn },
      { id: 31, val: amount_c_rap },
      { id: 32, val: amount_p_rkn },
      { id: 33, val: amount_p_rap },
    ];

    // 2. Sumamos los fijos
    let sumaFijos = fijos.reduce((acc, item) => {
      const monto = parseFloat(String(item.val || 0).replace(/,/g, "")) || 0;
      return acc + monto;
    }, 0);

    let sumaDinamicos = 0;

    if (conceptosDinamicos.length > 0) {
      // 3. Sumamos los que sí vienen del back (Manejo, Screening, Fleje, etc.)
      sumaDinamicos = conceptosDinamicos.reduce((acc, curr) => {
        const montoLimpio = String(curr.amount).replace(/,/g, "");
        return acc + (parseFloat(montoLimpio) || 0);
      }, 0);
    } else {
      // 4. Si no hay respuesta del back aún, sumamos los valores iniciales de manejo/screening
      const iniciales = [
        amount_handling,
        amount_refri,
        amount_conge,
        amount_screening,
        amount_dg_fee,
        amount_custom_value,
        flejeEmpaqueMonto
      ];
      sumaDinamicos = iniciales.reduce((acc, val) => {
        const monto = parseFloat(String(val || 0).replace(/,/g, "")) || 0;
        return acc + monto;
      }, 0);
    }

    // 5. EL SUBTOTAL REAL ES LA SUMA DE AMBOS
    const nuevoSubtotal = sumaFijos + sumaDinamicos;

    // 6. Cálculos de impuestos con redondeo
    const nuevoIva = Math.ceil((nuevoSubtotal * 0.16) * 100) / 100;
    const nuevoTotal = Math.ceil((nuevoSubtotal + nuevoIva) * 100) / 100;

    setSubtotal(nuevoSubtotal);
    setIva(nuevoIva);
    setTotal(nuevoTotal);

  }, [conceptosDinamicos,
    flejeEmpaqueMonto,
    amount_dg_exmept,
    amount_ice,
    amount_c_rap,
    amount_c_rkn,
    amount_conge,
    amount_custom_value,
    amount_dg_fee,
    amount_handling,
    amount_p_rap,
    amount_p_rkn,
    amount_refri,
    amount_screening]);


  const formatCurrency = (num) => {
    return Number(num).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const handleGuardar = async () => {
  
    if (!formData.agencia || !formData.clientId) {
      return Swal.fire("Campos requeridos", "Por favor selecciona una Agencia y un Cliente", "warning");
    }

    try {
      const body = {
        master_id: resp?.master_id,
        house_id: initialData?.house_id || null, 
        pediment: initialData?.pediment || null,
        pieces: initialData?.pieces || null,
        weight: initialData?.weight || null,
        admin_invoice: initialData?.admin_invoice || null,
        agent_id: formData.clientId, 
        client_id: formData.clientId,
        custom_value: formData.valorAduana || "0",
        observations: formData.observaciones || "",
        // Valores de empaque mapeados desde el array de cantidades
        strip_skid_160: cantidades[0]?.toString(),
        strip_skid_medium: cantidades[1]?.toString(),
        strip_loose: cantidades[2]?.toString(),
        vitafilm_skid_160: cantidades[3]?.toString(),
        vitafilm_skid_medium: cantidades[4]?.toString(),
        vitafilm_loose: cantidades[5]?.toString(),
        pallet_supply_std: cantidades[6]?.toString(),
        pallet_supply_eur: cantidades[7]?.toString(),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/expo_invoices/exp_invoice_save`,
        body,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.status === 200 || response.status === 200) {
        Swal.fire({
          title: "Éxito",
          text: "Folio de Facturación Generado con éxito",
          icon: "success",
          confirmButtonText: "cerrar"
        })
        onInvoiceCreated(response.data);
      }
    } catch (error) {
      console.error("Error al guardar factura:", error);
      Swal.fire(
        "Error",
        error.response?.data?.error || "Hubo un problema al generar la factura",
        "error"
      );
    } 
  };



  return (
    <>
      <Helmet><title>Horus | Búsqueda master</title></Helmet>
      <ScrollToTop />
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 mt-4">
            <div className="row">
              {[
                { label: "Master", value: masterNumber || "N/A" },
                { label: "Origen", value: resp?.master_orig || "N/A" },
                { label: "Destino", value: resp?.master_dest || "N/A" },
                { label: "Tipo de mercancía", value: resp?.master_merch || "N/A" },
                { label: "Piezas Master", value: resp?.master_pieces || "N/A" },
                { label: "Peso Master", value: resp?.master_chargeable_weight || "N/A" },
              ].map((item, index) => (
                <div key={index} className="col-md-3 pb-3 pb-md-5">
                  <span className="fw-bold">{item.label}: </span>{item.value}
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-md-3 mb-3">
            <label className="fw-bold">Agencia aduanal o Almacén *</label>
            <CustomSelect
              options={agents}
              labelKey="name"
              value={agents.find((a) => a.name === formData.agencia) || null}
              onSelect={(selected) => handleFormChange("agencia", selected ? selected.name : "")}
            />
          </div>
          <div className="col-md-3 mb-3">
            <label className="fw-bold">Clientes *</label>
            <CustomSelect
              options={clients}
              labelKey="name"
              onSelect={onSelectCliente}
            />
          </div>
          <div className="col-md-3 mt-3 mt-md-0">
            <label className="fw-bold">Valor aduana</label>
            <input
              type="number"
              className="form-control"
              value={formData.valorAduana}
              // Actualiza el número en el campo (visual)
              onChange={(e) => handleFormChange("valorAduana", e.target.value)}
              // Al hacer clic fuera, ejecuta el Web Service
              onFocus={() => handleInputFocus(null, true)}
              // Repone el 0 si está vacío y ejecuta los WS
              onBlur={async (e) => {
                let val = e.target.value;
                if (val === "") {
                  val = "0";
                  handleFormChange("valorAduana", "0");
                }
                await getCustomValue(val);
                getExpRules(formData.clientId || null, cantidades, val);
              }}
            />
          </div>
          <div className="col-md-3 mt-3 mt-md-0">
            <label className="fw-bold">Observaciones</label>
            <input
              type="text"
              className="form-control"
              value={formData.observaciones}
              onChange={(e) => handleFormChange("observaciones", e.target.value)}
            />
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-md-6 text-center">
            <table className="table fondo-headBilling">
              <thead><tr><th>Nombre</th><th>Cantidad</th></tr></thead>
              <tbody>
                {[
                  "Fleje skid 1.60 cm", "Fleje skid medio", "Fleje pza suelta",
                  "Vitafilm skid 1.60 cm", "Vitafilm skid medio", "Vitafilm pza suelta",
                  "Suministro Tarima Std", "Suministro Tarima Eur",
                ].map((nombre, i) => (
                  <tr key={i}>
                    <td>{nombre}</td>
                    <td>
                      <input
                        type="number"
                        className="form-control text-center"
                        value={cantidades[i]}
                        // Solo cambia el valor en el input
                        onChange={(e) => handleCantidadInputChange(i, e.target.value)}
                        // Lógica para borrar el 0 al entrar
                        onFocus={() => handleInputFocus(i)}
                        // Lógica para reponer el 0 al salir y disparar WS
                        onBlur={() => handleCantidadBlur(i)}
                        min="0"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="col-md-6 text-center">
            <table className="table fondo-headBilling">
              <thead>
                <tr><th>Concepto</th><th>Monto</th><th>Excepción</th><th>Reglas C.</th></tr>
              </thead>
              <tbody>
                {[
                  { id: 13, concepto: "Manejo de carga", val: amount_handling },
                  { id: 14, concepto: "Refrigeración", val: amount_refri },
                  { id: 15, concepto: "Congelación", val: amount_conge },
                  { id: 16, concepto: "Screening", val: amount_screening },
                  { id: 17, concepto: "DG Fee", val: amount_dg_fee },
                  { id: 18, concepto: "Manejo por valor", val: amount_custom_value },
                  { id: 19, concepto: "Fleje y empaque", val: flejeEmpaqueMonto },
                  { id: 22, concepto: "DG exentas", val: amount_dg_exmept },
                  { id: 23, concepto: "Hielo seco", val: amount_ice },
                  // AQUÍ ESTÁN LOS QUE FALTABAN:
                  { id: 30, concepto: "Cont. Activos (RKN)", val: amount_c_rkn },
                  { id: 31, concepto: "Cont. Activos (RAP)", val: amount_c_rap },
                  { id: 32, concepto: "Preparación de cont. (RKN)", val: amount_p_rkn },
                  { id: 33, concepto: "Preparación de cont. (RAP)", val: amount_p_rap },
                ].map((item, i) => (
                  <tr key={i}>
                    <td>{item.concepto}</td>
                    <td>{formatCurrency(getMontoFinal(item.id, item.val))}</td>
                    <td>N/A</td>
                    <td>{conceptosDinamicos.find(c => c.exp_charge_id === item.id)?.name || "N/A"}</td>
                  </tr>
                ))}
                <tr className="bor-bot">
                  <td className="text-center fw-bold">Subtotal</td>
                  <td className="text-center">{formatCurrency(Number(subtotalView).toFixed(2))}</td>
                  <td>-</td><td>-</td>
                </tr>
                <tr>
                  <td className="text-center fw-bold">IVA 16%</td>
                  <td className="text-center">{formatCurrency(Number(ivaView).toFixed(2))}</td>
                  <td>-</td><td>-</td>
                </tr>
                <tr>
                  <td className="text-center fw-bold">Total</td>
                  <td className="text-center">{formatCurrency(Number(totalView).toFixed(2))}</td>
                  <td>-</td><td>-</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="row">
          <div className="btns mt-3 d-flex justify-content-end gap-3">
            <button className="btnn" onClick={handleGuardar}>Emitir Forlio</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default BillingData;